import { render } from "./ImageViewer.vue?vue&type=template&id=f8e888d2&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import "./ImageViewer.vue?vue&type=style&index=0&id=f8e888d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e888d2"]])

export default __exports__